import React from "react";
import { string, array, oneOf, shape, object } from "prop-types";
import cx from "classnames";

import Taxonomy from "../Taxonomy/Taxonomy.jsx";

const propTypes = {
  imagePosition: oneOf(["", "left", "right"]),
  media: string,
  sizes: string,
  title: string,
  body: string,
  taxonomy: array,
  contentType: string,
  date: string,
  link: shape({
    href: string,
    text: string,
    title: string,
  }),
  focusRef: object, // for React Search apps
};

const listItem = (props) => {
  const {
    imagePosition,
    media,
    sizes,
    title,
    body,
    taxonomy,
    contentType,
    date,
    link,
    focusRef,
  } = props;

  return (
    <div
      className={cx("list-item", {
        "list-item--left": imagePosition === "left",
        "list-item--right": imagePosition === "right",
      })}
    >
      {media && (
        <div
          className="list-item__media js-list-item-clickable"
          data-location={link.href}
          onClick={() => (window.location = link.href)}
        >
          <img srcSet={media} alt="" sizes={sizes} />
        </div>
      )}
      <div className="list-item__content">
        {(contentType || date) && (
          <div className="list-item__eyebrow-area">
            {contentType && (
              <div className="list-item__content-type">{contentType}</div>
            )}
            {date && <div className="list-item__date">{date}</div>}
          </div>
        )}
        {taxonomy && (
          <div className="list-item__taxonomy">
            <Taxonomy values={taxonomy} />
          </div>
        )}
        <div className="list-item__title">
          <a href={link.href} className="list-item__cta" ref={focusRef}>
            {title}
          </a>
        </div>
        <div
          className="list-item__description"
          dangerouslySetInnerHTML={{ __html: body }}
        />
      </div>
    </div>
  );
};

listItem.propTypes = propTypes;
export default listItem;
